import Vue from "vue";
import {reportYear, entityOaid} from '../../util/util'
const report_year_list=reportYear.esg_report_years
let vm = {
  delimiters: ['{', '}'],
  props: {

  },
  data: () => {
    return {
      oaid: null,
      industry: "",
      officialName: "",
      report_date: [],
      report_option: "0",
      report_list: null,
      report_month_list: null,
      selectEvent: false,
      rating_data_info_show: false, // ?内容是否显示
      time_key: true, // setTimeInfo中用到的开关，如果为真,执行定时器内函数
      download_file_name: 'ESG评价数据说明.pdf',
      download_file: '/documents/quantdata-ESG-indicator.pdf',
    }
  },
  methods: {
    callIndicationTable(){
      let self = this
      reportYear.esg_report_month().then(result => {
        self.report_month_list =result.report_month_list
        self.report_list = result.report_annual_list.slice(0,-1)
        self.getESGData()
      })
      let id = this.$route.params.oaid
      entityOaid.oaid(id).then(result => {
        self.oaid =result
      })
    },
    getESGData(){
      this.report_date = []
      if (this.report_option === "0") {
        this.report_date = this.report_month_list.slice(0, 12)
      } else {
        for (let i in this.report_month_list) {
          if (this.report_month_list[i].startsWith(this.report_option)) {
            this.report_date.push(this.report_month_list[i])
          }
        }
      }
    },
    infoDivMouseEnter() {
      this.time_key=false
    },
    infoDivMouseMove() {
      this.rating_data_info_show=false
      this.time_key = true
    },
    // 离开问号后使其延时关闭
    setInfoTime() {
      setTimeout(()=>{
        if (this.time_key) this.rating_data_info_show=false
      },500)
    },
  },
  mounted () {
    this.callIndicationTable()
  },
  watch: {
    report_option: function () {
      this.getESGData()
      this.selectEvent = !this.selectEvent
    }
  }
}
Vue.component("esg-entity-rating", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_entity_rating.js